import { Flex, Spacing } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'

import { Attachment } from '../../types/attachment'
import { splitAttachmentsByUploadStatus } from '../../utils/splitAttachmentsByUploadStatus'
import { CompletedAttachmentTags } from './elements/CompletedAttachmentTags'
import { UploadingAttachmentItems } from './elements/UploadingAttachmentItems'

interface AttachmentsListProps {
  attachments: Attachment[]
  onCancelUpload: (id: string) => void
  onRemoveAttachment: (id: string) => void
  onRetryUpload: (id: string) => void
}

export const AttachmentsList = ({
  attachments,
  onCancelUpload,
  onRemoveAttachment,
  onRetryUpload,
}: AttachmentsListProps): ReactElement => {
  const { completedAttachments, uploadingAttachments } = useMemo(
    () => splitAttachmentsByUploadStatus(attachments),
    [attachments],
  )

  return (
    <Flex flexDirection="column" gap={Spacing.S12}>
      <CompletedAttachmentTags
        completedAttachments={completedAttachments}
        onRemoveAttachment={onRemoveAttachment}
        onRetryUpload={onRetryUpload}
      />
      <UploadingAttachmentItems onCancelUpload={onCancelUpload} uploadingAttachments={uploadingAttachments} />
    </Flex>
  )
}
